export default __webpack_public_path__ + "7ad00c9b5e3c4e20b40354558913cafb.svg";